export const administrativeDivisions = [
    {
        country: "India",
        name: "Andhra Pradesh",
        stateCode: "AP",
        region: "Southern",
        type: "State",
    },
    {
        country: "India",
        name: "Arunachal Pradesh",
        stateCode: "AR",
        region: "Northeastern",
        type: "State",
    },
    {
        country: "India",
        name: "Assam",
        stateCode: "AS",
        region: "Northeastern",
        type: "State",
    },
    {
        country: "India",
        name: "Bihar",
        stateCode: "BR",
        region: "Eastern",
        type: "State",
    },
    {
        country: "India",
        name: "Chhattisgarh",
        stateCode: "CG",
        region: "Central",
        type: "State",
    },
    {
        country: "India",
        name: "Goa",
        stateCode: "GA",
        region: "Western",
        type: "State",
    },
    {
        country: "India",
        name: "Gujarat",
        stateCode: "GJ",
        region: "Western",
        type: "State",
    },
    {
        country: "India",
        name: "Haryana",
        stateCode: "HR",
        region: "Northern",
        type: "State",
    },
    {
        country: "India",
        name: "Himachal Pradesh",
        stateCode: "HP",
        region: "Northern",
        type: "State",
    },
    {
        country: "India",
        name: "Jharkhand",
        stateCode: "JH",
        region: "Eastern",
        type: "State",
    },
    {
        country: "India",
        name: "Karnataka",
        stateCode: "KA",
        region: "Southern",
        type: "State",
    },
    {
        country: "India",
        name: "Kerala",
        stateCode: "KL",
        region: "Southern",
        type: "State",
    },
    {
        country: "India",
        name: "Madhya Pradesh",
        stateCode: "MP",
        region: "Central",
        type: "State",
    },
    {
        country: "India",
        name: "Maharashtra",
        stateCode: "MH",
        region: "Western",
        type: "State",
    },
    {
        country: "India",
        name: "Manipur",
        stateCode: "MN",
        region: "Northeastern",
        type: "State",
    },
    {
        country: "India",
        name: "Meghalaya",
        stateCode: "ML",
        region: "Northeastern",
        type: "State",
    },
    {
        country: "India",
        name: "Mizoram",
        stateCode: "MZ",
        region: "Northeastern",
        type: "State",
    },
    {
        country: "India",
        name: "Nagaland",
        stateCode: "NL",
        region: "Northeastern",
        type: "State",
    },
    {
        country: "India",
        name: "Odisha",
        stateCode: "OR",
        region: "Eastern",
        type: "State",
    },
    {
        country: "India",
        name: "Punjab",
        stateCode: "PB",
        region: "Northern",
        type: "State",
    },
    {
        country: "India",
        name: "Rajasthan",
        stateCode: "RJ",
        region: "Northern",
        type: "State",
    },
    {
        country: "India",
        name: "Sikkim",
        stateCode: "SK",
        region: "Northeastern",
        type: "State",
    },
    {
        country: "India",
        name: "Tamil Nadu",
        stateCode: "TN",
        region: "Southern",
        type: "State",
    },
    {
        country: "India",
        name: "Telangana",
        stateCode: "TG",
        region: "Southern",
        type: "State",
    },
    {
        country: "India",
        name: "Tripura",
        stateCode: "TR",
        region: "Northeastern",
        type: "State",
    },
    {
        country: "India",
        name: "Uttarakhand",
        stateCode: "UK",
        region: "Northern",
        type: "State",
    },
    {
        country: "India",
        name: "Uttar Pradesh",
        stateCode: "UP",
        region: "Central",
        type: "State",
    },
    {
        country: "India",
        name: "West Bengal",
        stateCode: "WB",
        region: "Eastern",
        type: "State",
    },
    {
        country: "India",
        name: "Andaman and Nicobar Islands",
        stateCode: "AN",
        region: "Southern",
        type: "Union Territory",
    },
    {
        country: "India",
        name: "Chandigarh",
        stateCode: "CH",
        region: "Northern",
        type: "Union Territory",
    },
    {
        country: "India",
        name: "Dadra and Nagar Haveli and Daman and Diu",
        stateCode: "DH",
        region: "Western",
        type: "Union Territory",
    },
    {
        country: "India",
        name: "Jammu and Kashmir",
        stateCode: "JK",
        region: "Northern",
        type: "Union Territory",
    },
    {
        country: "India",
        name: "Ladakh",
        stateCode: "LA",
        region: "Northern",
        type: "Union Territory",
    },
    {
        country: "India",
        name: "Lakshadweep",
        stateCode: "LD",
        region: "Southern",
        type: "Union Territory",
    },
    {
        country: "India",
        name: "Puducherry",
        stateCode: "PY",
        region: "Southern",
        type: "Union Territory",
    },
    {
        country: "India",
        name: "New Delhi",
        stateCode: "DL",
        region: "Northern",
        type: "Union Territory",
    },
    {
        country: "Oman",
        name: "Muscat",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Oman",
        name: "Dhofar",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Oman",
        name: "Musandam",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Oman",
        name: "Al Buraimi",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Oman",
        name: "Ad Dakhiliyah",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Oman",
        name: "Al Wusta",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Oman",
        name: "Ash Sharqiyah North",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Oman",
        name: "Ash Sharqiyah South",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Oman",
        name: "Al Batinah North",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Oman",
        name: "Al Batinah South",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "UAE",
        name: "Abu Dhabi",
        stateCode: null,
        region: null,
        type: "Emirate",
    },
    {
        country: "UAE",
        name: "Dubai",
        stateCode: null,
        region: null,
        type: "Emirate",
    },
    {
        country: "UAE",
        name: "Sharjah",
        stateCode: null,
        region: null,
        type: "Emirate",
    },
    {
        country: "UAE",
        name: "Ajman",
        stateCode: null,
        region: null,
        type: "Emirate",
    },
    {
        country: "UAE",
        name: "Umm Al-Quwain",
        stateCode: null,
        region: null,
        type: "Emirate",
    },
    {
        country: "UAE",
        name: "Ras Al Khaimah",
        stateCode: null,
        region: null,
        type: "Emirate",
    },
    {
        country: "UAE",
        name: "Fujairah",
        stateCode: null,
        region: null,
        type: "Emirate",
    },
    {
        country: "Kuwait",
        name: "Al Asimah (Capital)",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Kuwait",
        name: "Hawalli",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Kuwait",
        name: "Farwaniya",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Kuwait",
        name: "Mubarak Al-Kabeer",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Kuwait",
        name: "Al Ahmadi",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Kuwait",
        name: "Jahra",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Qatar",
        name: "Doha",
        stateCode: null,
        region: null,
        type: "Municipality",
    },
    {
        country: "Qatar",
        name: "Al Rayyan",
        stateCode: null,
        region: null,
        type: "Municipality",
    },
    {
        country: "Qatar",
        name: "Al Wakrah",
        stateCode: null,
        region: null,
        type: "Municipality",
    },
    {
        country: "Qatar",
        name: "Umm Salal",
        stateCode: null,
        region: null,
        type: "Municipality",
    },
    {
        country: "Qatar",
        name: "Al Khor",
        stateCode: null,
        region: null,
        type: "Municipality",
    },
    {
        country: "Qatar",
        name: "Al Shamal",
        stateCode: null,
        region: null,
        type: "Municipality",
    },
    {
        country: "Qatar",
        name: "Al Daayen",
        stateCode: null,
        region: null,
        type: "Municipality",
    },
    {
        country: "Qatar",
        name: "Al Shahaniya",
        stateCode: null,
        region: null,
        type: "Municipality",
    },
    {
        country: "Saudi Arabia",
        name: "Riyadh",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Makkah",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Madinah",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Eastern Province (Ash Sharqiyah)",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Qassim",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Hail",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Northern Borders",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Jazan",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Najran",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Al Bahah",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Tabuk",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Asir",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Saudi Arabia",
        name: "Al Jouf",
        stateCode: null,
        region: null,
        type: "Region",
    },
    {
        country: "Bahrain",
        name: "Capital Governorate",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Bahrain",
        name: "Muharraq Governorate",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Bahrain",
        name: "Northern Governorate",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
    {
        country: "Bahrain",
        name: "Southern Governorate",
        stateCode: null,
        region: null,
        type: "Governorate",
    },
];
/** Mirrors Android `administrativeDivisions.find { … }?.name ?: region` for Act_SignUp / leads. */
export function normalizeStateRegionForLsq(region) {
    if (!region?.trim())
        return undefined;
    const trimmed = region.trim();
    const found = administrativeDivisions.find((d) => d.name?.toLowerCase() === trimmed.toLowerCase());
    return found?.name ?? trimmed;
}
